// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ek_n","rightAdornment":"Header_rightAdornment__2V3Jp"};